export default "__VITE_ASSET__uJT0WtPu__"